import { ReactNode, ButtonHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

import { ButtonContainer } from './styles';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>  {
  children: ReactNode;
  className?: string;
  outline?: boolean;
  go?: string;
}

function Button({ children, className = '', outline, go, ...rest }: ButtonProps) {
  return (
    <ButtonContainer className={`button ${ className } ${outline && 'outline'}`} { ...rest }>
      { children }
      { go && <Link to={go}></Link>}
    </ButtonContainer>
  );
};

export default Button;
